import { render, staticRenderFns } from "./newPie.vue?vue&type=template&id=6d7174b8&scoped=true"
import script from "./newPie.vue?vue&type=script&lang=js"
export * from "./newPie.vue?vue&type=script&lang=js"
import style0 from "./newPie.vue?vue&type=style&index=0&id=6d7174b8&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7174b8",
  null
  
)

export default component.exports